import * as React from "react";

import getGenePalette from "../getGenePalette";
import GeneSnpShapes from "../shared/GeneSnpShapes";
import { geneGroupProps } from "../shared/geneGroupProps";
import getGeneSnpCount from "../shared/getGeneSnpCount";

export const MethylationBh4CycleDiagramContent = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick
}) => {
  const dhfr = getGenePalette(geneColors.DHFR);
  const th = getGenePalette(geneColors.TH);
  const comt = getGenePalette(geneColors.COMT);
  const tph = getGenePalette(geneColors.TPH);
  const nos3 = getGenePalette(geneColors.NOS3);
  const sod1_3 = getGenePalette(geneColors["SOD1/3"]);
  const gpx1 = getGenePalette(geneColors.GPX1);

  return (
    <>
      <g id="diagram" clipPath="url(#clip1_18291_211490)">
        <rect width={1424} height={869} transform="translate(0 176)" fill="white" />
        <g id="BH4-cycle-diagram">
          <rect width={1424} height={869} transform="translate(0 176)" fill="white" />
          <g id="lines_2">
            <path
              id="Vector_3"
              d="M381 251.042L388 255.083V247L381 251.042ZM546.3 251.742H547V250.342H546.3V251.042V251.742ZM387.3 251.042V251.742L546.3 251.742V251.042V250.342L387.3 250.342V251.042Z"
              fill="#E44C4B"
            />
          </g>
          <g id="lines_3">
            <text
              fontFamily="Gilroy W05 Medium"
              id="Line Label"
              transform="translate(765 503)"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={14}
              letterSpacing="0em"
            >
              <tspan x={71.9385} y={16.767}>
                Decrease BH4
              </tspan>
            </text>
            <path
              id="Vector_4"
              d="M765.7 530.7L999.3 530.7"
              stroke="#E44C4B"
              strokeWidth={1.4}
              strokeLinecap="round"
              strokeDasharray="4 4"
            />
          </g>
          <g id="lines_4">
            <text
              fontFamily="Gilroy W05 Medium"
              id="Line Label_2"
              transform="translate(316 375) rotate(-90)"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={14}
              letterSpacing="0em"
            >
              <tspan x={18.666} y={16.767}>
                Removes
              </tspan>
            </text>
            <path
              id="Vector_5"
              d="M346.341 374.3L346.341 375L347.741 375L347.741 374.3L347.041 374.3L346.341 374.3ZM347.041 280L343 287L351.082 287L347.041 280ZM347.041 374.3L347.741 374.3L347.741 286.3L347.041 286.3L346.341 286.3L346.341 374.3L347.041 374.3Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_5">
            <path
              id="Vector_6"
              d="M1175.74 500.7L1175.74 500L1174.34 500L1174.34 500.7L1175.04 500.7L1175.74 500.7ZM1175.04 578L1179.08 571L1171 571L1175.04 578ZM1175.04 500.7L1174.34 500.7L1174.34 571.7L1175.04 571.7L1175.74 571.7L1175.74 500.7L1175.04 500.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_6">
            <path
              id="Vector_7"
              d="M203.742 578.7C203.742 578.314 203.429 578 203.042 578C202.655 578 202.342 578.314 202.342 578.7L203.042 578.7L203.742 578.7ZM203.042 636L207.083 629L199.001 629L203.042 636ZM202.342 580.747C202.342 581.133 202.655 581.447 203.042 581.447C203.429 581.447 203.742 581.133 203.742 580.747L203.042 580.747L202.342 580.747ZM203.742 584.839C203.742 584.453 203.429 584.139 203.042 584.139C202.655 584.139 202.342 584.453 202.342 584.839L203.042 584.839L203.742 584.839ZM202.342 588.932C202.342 589.319 202.655 589.632 203.042 589.632C203.429 589.632 203.742 589.319 203.742 588.932L203.042 588.932L202.342 588.932ZM203.742 593.025C203.742 592.639 203.429 592.325 203.042 592.325C202.655 592.325 202.342 592.639 202.342 593.025L203.042 593.025L203.742 593.025ZM202.342 597.118C202.342 597.505 202.655 597.818 203.042 597.818C203.429 597.818 203.742 597.505 203.742 597.118L203.042 597.118L202.342 597.118ZM203.742 601.211C203.742 600.824 203.429 600.511 203.042 600.511C202.655 600.511 202.342 600.824 202.342 601.211L203.042 601.211L203.742 601.211ZM202.342 605.304C202.342 605.69 202.655 606.004 203.042 606.004C203.429 606.004 203.742 605.69 203.742 605.304L203.042 605.304L202.342 605.304ZM203.742 609.397C203.742 609.01 203.429 608.697 203.042 608.697C202.655 608.697 202.342 609.01 202.342 609.397L203.042 609.397L203.742 609.397ZM202.342 613.489C202.342 613.876 202.655 614.189 203.042 614.189C203.429 614.189 203.742 613.876 203.742 613.489L203.042 613.489L202.342 613.489ZM203.742 617.582C203.742 617.196 203.429 616.882 203.042 616.882C202.655 616.882 202.342 617.196 202.342 617.582L203.042 617.582L203.742 617.582ZM202.342 621.675C202.342 622.062 202.655 622.375 203.042 622.375C203.429 622.375 203.742 622.062 203.742 621.675L203.042 621.675L202.342 621.675ZM203.742 625.768C203.742 625.381 203.429 625.068 203.042 625.068C202.655 625.068 202.342 625.381 202.342 625.768L203.042 625.768L203.742 625.768ZM202.342 629.861C202.342 630.248 202.655 630.561 203.042 630.561C203.429 630.561 203.742 630.248 203.742 629.861L203.042 629.861L202.342 629.861ZM203.742 633.954C203.742 633.567 203.429 633.254 203.042 633.254C202.655 633.254 202.342 633.567 202.342 633.954L203.042 633.954L203.742 633.954ZM203.042 578.7L202.342 578.7L202.342 580.747L203.042 580.747L203.742 580.747L203.742 578.7L203.042 578.7ZM203.042 584.839L202.342 584.839L202.342 588.932L203.042 588.932L203.742 588.932L203.742 584.839L203.042 584.839ZM203.042 593.025L202.342 593.025L202.342 597.118L203.042 597.118L203.742 597.118L203.742 593.025L203.042 593.025ZM203.042 601.211L202.342 601.211L202.342 605.304L203.042 605.304L203.742 605.304L203.742 601.211L203.042 601.211ZM203.042 609.397L202.342 609.397L202.342 613.489L203.042 613.489L203.742 613.489L203.742 609.397L203.042 609.397ZM203.042 617.582L202.342 617.582L202.342 621.675L203.042 621.675L203.742 621.675L203.742 617.582L203.042 617.582ZM203.042 625.768L202.342 625.768L202.342 629.861L203.042 629.861L203.742 629.861L203.742 625.768L203.042 625.768Z"
              fill="#818181"
            />
          </g>
          <g id="lines_7">
            <path
              id="Vector_8"
              d="M411.742 578.7C411.742 578.314 411.429 578 411.042 578C410.655 578 410.342 578.314 410.342 578.7L411.042 578.7L411.742 578.7ZM411.042 636L415.083 629L407.001 629L411.042 636ZM410.342 580.747C410.342 581.133 410.655 581.447 411.042 581.447C411.429 581.447 411.742 581.133 411.742 580.747L411.042 580.747L410.342 580.747ZM411.742 584.839C411.742 584.453 411.429 584.139 411.042 584.139C410.655 584.139 410.342 584.453 410.342 584.839L411.042 584.839L411.742 584.839ZM410.342 588.932C410.342 589.319 410.655 589.632 411.042 589.632C411.429 589.632 411.742 589.319 411.742 588.932L411.042 588.932L410.342 588.932ZM411.742 593.025C411.742 592.639 411.429 592.325 411.042 592.325C410.655 592.325 410.342 592.639 410.342 593.025L411.042 593.025L411.742 593.025ZM410.342 597.118C410.342 597.505 410.655 597.818 411.042 597.818C411.429 597.818 411.742 597.505 411.742 597.118L411.042 597.118L410.342 597.118ZM411.742 601.211C411.742 600.824 411.429 600.511 411.042 600.511C410.655 600.511 410.342 600.824 410.342 601.211L411.042 601.211L411.742 601.211ZM410.342 605.304C410.342 605.69 410.655 606.004 411.042 606.004C411.429 606.004 411.742 605.69 411.742 605.304L411.042 605.304L410.342 605.304ZM411.742 609.397C411.742 609.01 411.429 608.697 411.042 608.697C410.655 608.697 410.342 609.01 410.342 609.397L411.042 609.397L411.742 609.397ZM410.342 613.489C410.342 613.876 410.655 614.189 411.042 614.189C411.429 614.189 411.742 613.876 411.742 613.489L411.042 613.489L410.342 613.489ZM411.742 617.582C411.742 617.196 411.429 616.882 411.042 616.882C410.655 616.882 410.342 617.196 410.342 617.582L411.042 617.582L411.742 617.582ZM410.342 621.675C410.342 622.062 410.655 622.375 411.042 622.375C411.429 622.375 411.742 622.062 411.742 621.675L411.042 621.675L410.342 621.675ZM411.742 625.768C411.742 625.381 411.429 625.068 411.042 625.068C410.655 625.068 410.342 625.381 410.342 625.768L411.042 625.768L411.742 625.768ZM410.342 629.861C410.342 630.248 410.655 630.561 411.042 630.561C411.429 630.561 411.742 630.248 411.742 629.861L411.042 629.861L410.342 629.861ZM411.742 633.954C411.742 633.567 411.429 633.254 411.042 633.254C410.655 633.254 410.342 633.567 410.342 633.954L411.042 633.954L411.742 633.954ZM411.042 578.7L410.342 578.7L410.342 580.747L411.042 580.747L411.742 580.747L411.742 578.7L411.042 578.7ZM411.042 584.839L410.342 584.839L410.342 588.932L411.042 588.932L411.742 588.932L411.742 584.839L411.042 584.839ZM411.042 593.025L410.342 593.025L410.342 597.118L411.042 597.118L411.742 597.118L411.742 593.025L411.042 593.025ZM411.042 601.211L410.342 601.211L410.342 605.304L411.042 605.304L411.742 605.304L411.742 601.211L411.042 601.211ZM411.042 609.397L410.342 609.397L410.342 613.489L411.042 613.489L411.742 613.489L411.742 609.397L411.042 609.397ZM411.042 617.582L410.342 617.582L410.342 621.675L411.042 621.675L411.742 621.675L411.742 617.582L411.042 617.582ZM411.042 625.768L410.342 625.768L410.342 629.861L411.042 629.861L411.742 629.861L411.742 625.768L411.042 625.768Z"
              fill="#818181"
            />
          </g>
          <g id="lines_8">
            <path
              id="Vector_9"
              d="M602.742 578.7C602.742 578.314 602.429 578 602.042 578C601.655 578 601.342 578.314 601.342 578.7L602.042 578.7L602.742 578.7ZM602.042 636L606.083 629L598.001 629L602.042 636ZM601.342 580.747C601.342 581.133 601.655 581.447 602.042 581.447C602.429 581.447 602.742 581.133 602.742 580.747L602.042 580.747L601.342 580.747ZM602.742 584.839C602.742 584.453 602.429 584.139 602.042 584.139C601.655 584.139 601.342 584.453 601.342 584.839L602.042 584.839L602.742 584.839ZM601.342 588.932C601.342 589.319 601.655 589.632 602.042 589.632C602.429 589.632 602.742 589.319 602.742 588.932L602.042 588.932L601.342 588.932ZM602.742 593.025C602.742 592.639 602.429 592.325 602.042 592.325C601.655 592.325 601.342 592.639 601.342 593.025L602.042 593.025L602.742 593.025ZM601.342 597.118C601.342 597.505 601.655 597.818 602.042 597.818C602.429 597.818 602.742 597.505 602.742 597.118L602.042 597.118L601.342 597.118ZM602.742 601.211C602.742 600.824 602.429 600.511 602.042 600.511C601.655 600.511 601.342 600.824 601.342 601.211L602.042 601.211L602.742 601.211ZM601.342 605.304C601.342 605.69 601.655 606.004 602.042 606.004C602.429 606.004 602.742 605.69 602.742 605.304L602.042 605.304L601.342 605.304ZM602.742 609.397C602.742 609.01 602.429 608.697 602.042 608.697C601.655 608.697 601.342 609.01 601.342 609.397L602.042 609.397L602.742 609.397ZM601.342 613.489C601.342 613.876 601.655 614.189 602.042 614.189C602.429 614.189 602.742 613.876 602.742 613.489L602.042 613.489L601.342 613.489ZM602.742 617.582C602.742 617.196 602.429 616.882 602.042 616.882C601.655 616.882 601.342 617.196 601.342 617.582L602.042 617.582L602.742 617.582ZM601.342 621.675C601.342 622.062 601.655 622.375 602.042 622.375C602.429 622.375 602.742 622.062 602.742 621.675L602.042 621.675L601.342 621.675ZM602.742 625.768C602.742 625.381 602.429 625.068 602.042 625.068C601.655 625.068 601.342 625.381 601.342 625.768L602.042 625.768L602.742 625.768ZM601.342 629.861C601.342 630.248 601.655 630.561 602.042 630.561C602.429 630.561 602.742 630.248 602.742 629.861L602.042 629.861L601.342 629.861ZM602.742 633.954C602.742 633.567 602.429 633.254 602.042 633.254C601.655 633.254 601.342 633.567 601.342 633.954L602.042 633.954L602.742 633.954ZM602.042 578.7L601.342 578.7L601.342 580.747L602.042 580.747L602.742 580.747L602.742 578.7L602.042 578.7ZM602.042 584.839L601.342 584.839L601.342 588.932L602.042 588.932L602.742 588.932L602.742 584.839L602.042 584.839ZM602.042 593.025L601.342 593.025L601.342 597.118L602.042 597.118L602.742 597.118L602.742 593.025L602.042 593.025ZM602.042 601.211L601.342 601.211L601.342 605.304L602.042 605.304L602.742 605.304L602.742 601.211L602.042 601.211ZM602.042 609.397L601.342 609.397L601.342 613.489L602.042 613.489L602.742 613.489L602.742 609.397L602.042 609.397ZM602.042 617.582L601.342 617.582L601.342 621.675L602.042 621.675L602.742 621.675L602.742 617.582L602.042 617.582ZM602.042 625.768L601.342 625.768L601.342 629.861L602.042 629.861L602.742 629.861L602.742 625.768L602.042 625.768Z"
              fill="#818181"
            />
          </g>
          <g id="lines_9">
            <path
              id="Vector_10"
              d="M812.742 578.7C812.742 578.314 812.429 578 812.042 578C811.655 578 811.342 578.314 811.342 578.7L812.042 578.7L812.742 578.7ZM812.042 636L816.083 629L808.001 629L812.042 636ZM811.342 580.747C811.342 581.133 811.655 581.447 812.042 581.447C812.429 581.447 812.742 581.133 812.742 580.747L812.042 580.747L811.342 580.747ZM812.742 584.839C812.742 584.453 812.429 584.139 812.042 584.139C811.655 584.139 811.342 584.453 811.342 584.839L812.042 584.839L812.742 584.839ZM811.342 588.932C811.342 589.319 811.655 589.632 812.042 589.632C812.429 589.632 812.742 589.319 812.742 588.932L812.042 588.932L811.342 588.932ZM812.742 593.025C812.742 592.639 812.429 592.325 812.042 592.325C811.655 592.325 811.342 592.639 811.342 593.025L812.042 593.025L812.742 593.025ZM811.342 597.118C811.342 597.505 811.655 597.818 812.042 597.818C812.429 597.818 812.742 597.505 812.742 597.118L812.042 597.118L811.342 597.118ZM812.742 601.211C812.742 600.824 812.429 600.511 812.042 600.511C811.655 600.511 811.342 600.824 811.342 601.211L812.042 601.211L812.742 601.211ZM811.342 605.304C811.342 605.69 811.655 606.004 812.042 606.004C812.429 606.004 812.742 605.69 812.742 605.304L812.042 605.304L811.342 605.304ZM812.742 609.397C812.742 609.01 812.429 608.697 812.042 608.697C811.655 608.697 811.342 609.01 811.342 609.397L812.042 609.397L812.742 609.397ZM811.342 613.489C811.342 613.876 811.655 614.189 812.042 614.189C812.429 614.189 812.742 613.876 812.742 613.489L812.042 613.489L811.342 613.489ZM812.742 617.582C812.742 617.196 812.429 616.882 812.042 616.882C811.655 616.882 811.342 617.196 811.342 617.582L812.042 617.582L812.742 617.582ZM811.342 621.675C811.342 622.062 811.655 622.375 812.042 622.375C812.429 622.375 812.742 622.062 812.742 621.675L812.042 621.675L811.342 621.675ZM812.742 625.768C812.742 625.381 812.429 625.068 812.042 625.068C811.655 625.068 811.342 625.381 811.342 625.768L812.042 625.768L812.742 625.768ZM811.342 629.861C811.342 630.248 811.655 630.561 812.042 630.561C812.429 630.561 812.742 630.248 812.742 629.861L812.042 629.861L811.342 629.861ZM812.742 633.954C812.742 633.567 812.429 633.254 812.042 633.254C811.655 633.254 811.342 633.567 811.342 633.954L812.042 633.954L812.742 633.954ZM812.042 578.7L811.342 578.7L811.342 580.747L812.042 580.747L812.742 580.747L812.742 578.7L812.042 578.7ZM812.042 584.839L811.342 584.839L811.342 588.932L812.042 588.932L812.742 588.932L812.742 584.839L812.042 584.839ZM812.042 593.025L811.342 593.025L811.342 597.118L812.042 597.118L812.742 597.118L812.742 593.025L812.042 593.025ZM812.042 601.211L811.342 601.211L811.342 605.304L812.042 605.304L812.742 605.304L812.742 601.211L812.042 601.211ZM812.042 609.397L811.342 609.397L811.342 613.489L812.042 613.489L812.742 613.489L812.742 609.397L812.042 609.397ZM812.042 617.582L811.342 617.582L811.342 621.675L812.042 621.675L812.742 621.675L812.742 617.582L812.042 617.582ZM812.042 625.768L811.342 625.768L811.342 629.861L812.042 629.861L812.742 629.861L812.742 625.768L812.042 625.768Z"
              fill="#818181"
            />
          </g>
          <g id="Cofactor_3">
            <g id="diamond_2">
              <text
                fontFamily="Gilroy W05 Medium"
                id="label"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={1199.18} y={531.086}>
                  NADPH
                </tspan>
              </text>
              <g id="Vector_11">
                <mask id="path-34-inside-2_18291_211490" fill="white">
                  <path d="M1219 502L1244 514.121V539.879L1219 552L1194 539.879V514.121L1219 502Z" />
                </mask>
                <path
                  d="M1219 502L1244 514.121V539.879L1219 552L1194 539.879V514.121L1219 502Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-34-inside-2_18291_211490)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_4">
            <g id="diamond_3">
              <text
                fontFamily="Gilroy W05 Medium"
                id="label_2"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={256.909} y={700.767}>
                  BH4
                </tspan>
              </text>
              <g id="Vector_12">
                <mask id="path-36-inside-3_18291_211490" fill="white">
                  <path d="M270 671L295 683.121V708.879L270 721L245 708.879V683.121L270 671Z" />
                </mask>
                <path
                  d="M270 671L295 683.121V708.879L270 721L245 708.879V683.121L270 671Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-36-inside-3_18291_211490)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_5">
            <g id="diamond_4">
              <text
                fontFamily="Gilroy W05 Medium"
                id="label_3"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={663.909} y={690.767}>
                  BH4
                </tspan>
              </text>
              <g id="Vector_13">
                <mask id="path-38-inside-4_18291_211490" fill="white">
                  <path d="M677 661L702 673.121V698.879L677 711L652 698.879V673.121L677 661Z" />
                </mask>
                <path
                  d="M677 661L702 673.121V698.879L677 711L652 698.879V673.121L677 661Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-38-inside-4_18291_211490)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_6">
            <g id="diamond_5">
              <text
                fontFamily="Gilroy W05 Medium"
                id="label_4"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={436.909} y={615.767}>
                  BH4
                </tspan>
              </text>
              <g id="Vector_14">
                <mask id="path-40-inside-5_18291_211490" fill="white">
                  <path d="M450 586L475 598.121V623.879L450 636L425 623.879V598.121L450 586Z" />
                </mask>
                <path
                  d="M450 586L475 598.121V623.879L450 636L425 623.879V598.121L450 586Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-40-inside-5_18291_211490)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_7">
            <g id="diamond_6">
              <text
                fontFamily="Gilroy W05 Medium"
                id="label_5"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={873.909} y={689.767}>
                  BH4
                </tspan>
              </text>
              <g id="Vector_15">
                <mask id="path-42-inside-6_18291_211490" fill="white">
                  <path d="M887 660L912 672.121V697.879L887 710L862 697.879V672.121L887 660Z" />
                </mask>
                <path
                  d="M887 660L912 672.121V697.879L887 710L862 697.879V672.121L887 660Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-42-inside-6_18291_211490)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_8">
            <g id="diamond_7">
              <text
                fontFamily="Gilroy W05 Medium"
                id="label_6"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={1153.94} y={725.767}>
                  Mg
                </tspan>
              </text>
              <g id="Vector_16">
                <mask id="path-44-inside-7_18291_211490" fill="white">
                  <path d="M1164 696L1189 708.121V733.879L1164 746L1139 733.879V708.121L1164 696Z" />
                </mask>
                <path
                  d="M1164 696L1189 708.121V733.879L1164 746L1139 733.879V708.121L1164 696Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-44-inside-7_18291_211490)"
                />
              </g>
            </g>
          </g>
          <g id="Report titles">
            <rect width={39} height={28} transform="translate(321 230)" fill="white" />
            <g id="25-Hydroxy Vitamin D">
              <text
                fontFamily="Gilroy W05 Medium"
                fill="#E44C4B"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={321.371} y={250.129}>
                  H
                </tspan>
                <tspan x={339.537} y={250.129}>
                  O
                </tspan>
              </text>
              <text
                fontFamily="Gilroy W05 Medium"
                fill="#E44C4B"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={333.518} y={250.129}>
                  &#x2082;
                </tspan>
                <tspan x={353.933} y={250.129}>
                  &#x2082;
                </tspan>
              </text>
            </g>
          </g>
          <g id="Report titles_2">
            <text
              fontFamily="Gilroy W05 Regular"
              id="25-Hydroxy Vitamin D_2"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={1266.86} y={434.12}>
                Folic Acid{" "}
              </tspan>
              <tspan x={1263.29} y={462.12}>
                and folate
              </tspan>
            </text>
          </g>
          <g id="Report titles_3">
            <text
              fontFamily="Gilroy W05 Regular"
              id="25-Hydroxy Vitamin D_3"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={1159.27} y={438.12}>
                DHF
              </tspan>
            </text>
          </g>
          <g id="Report titles_4">
            <text
              fontFamily="Gilroy W05 Regular"
              id="25-Hydroxy Vitamin D_4"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={878.274} y={395.12}>
                STRESS
              </tspan>
            </text>
          </g>
          <g id="Report titles_5">
            <text
              fontFamily="Gilroy W05 Regular"
              id="25-Hydroxy Vitamin D_5"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={24}
              letterSpacing="0em"
            >
              <tspan x={421.02} y={642.16}>
                +
              </tspan>
            </text>
          </g>
          <g id="Report titles_6">
            <text
              fontFamily="Gilroy W05 Regular"
              id="25-Hydroxy Vitamin D_6"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={1159.39} y={599.12}>
                THF
              </tspan>
            </text>
          </g>
          <g id="Report titles_7">
            <rect width={105} height={20} transform="translate(863 199)" fill="white" />
            <text
              fontFamily="Gilroy W05 Regular"
              id="25-Hydroxy Vitamin D_7"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={863.094} y={213.08}>
                Uncoupled Enzyme
              </tspan>
            </text>
          </g>
          <g id="Report titles_8">
            <rect x={579.7} y={319.7} width={235.6} height={226.6} fill="white" />
            <rect
              x={579.7}
              y={319.7}
              width={235.6}
              height={226.6}
              stroke="#E44C4B"
              strokeWidth={1.4}
              strokeDasharray="4 4"
            />
            <text
              fontFamily="Gilroy W05 Regular"
              id="25-Hydroxy Vitamin D_8"
              fill="#E44C4B"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={595} y={354.44}>
                BPA{" "}
              </tspan>
              <tspan x={595} y={382.44}>
                Smoking{" "}
              </tspan>
              <tspan x={595} y={410.44}>
                Aluminium{" "}
              </tspan>
              <tspan x={595} y={438.44}>
                Chemotherapy{" "}
              </tspan>
              <tspan x={595} y={466.44}>
                Perfluorinated substances{" "}
              </tspan>
              <tspan x={595} y={494.44}>
                Chronic viral infections (long{" "}
              </tspan>
              <tspan x={595} y={522.44}>
                COVID, hepatitis etc.)
              </tspan>
            </text>
          </g>
          <g id="Report titles_9">
            <rect width={49} height={28} transform="translate(1007 327)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              id="25-Hydroxy Vitamin D_9"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={1015.14} y={347.129}>
                BH2
              </tspan>
            </text>
          </g>
          <g id="report-label">
            <g id="Report titles_10">
              <rect width={66} height={28} transform="translate(171 639)" fill="white" />
              <text
                fontFamily="Gilroy W05 Regular"
                id="25-Hydroxy Vitamin D_10"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={171.05} y={659.12}>
                  Arginine
                </tspan>
              </text>
            </g>
            <g id="lines_10">
              <path
                id="Vector_17"
                d="M204.659 671.7L204.659 671L203.259 671L203.259 671.7L203.959 671.7L204.659 671.7ZM203.959 792L208 785L199.918 785L203.959 792ZM203.959 671.7L203.259 671.7L203.259 785.7L203.959 785.7L204.659 785.7L204.659 671.7L203.959 671.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="report-label_2">
            <g id="Report titles_11">
              <rect width={137} height={28} transform="translate(135 794)" fill="white" />
              <text
                fontFamily="Gilroy W05 Regular"
                id="25-Hydroxy Vitamin D_11"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={135.446} y={814.12}>
                  Nitric Oxide (NO)
                </tspan>
              </text>
            </g>
            <g id="lines_11">
              <path
                id="Vector_18"
                d="M204.159 826.7C204.159 826.314 203.846 826 203.459 826C203.072 826 202.759 826.314 202.759 826.7L203.459 826.7L204.159 826.7ZM203.459 937L207.5 930L199.418 930L203.459 937ZM202.759 828.67C202.759 829.056 203.072 829.37 203.459 829.37C203.846 829.37 204.159 829.056 204.159 828.67L203.459 828.67L202.759 828.67ZM204.159 832.609C204.159 832.223 203.846 831.909 203.459 831.909C203.072 831.909 202.759 832.223 202.759 832.609L203.459 832.609L204.159 832.609ZM202.759 836.548C202.759 836.935 203.072 837.248 203.459 837.248C203.846 837.248 204.159 836.935 204.159 836.548L203.459 836.548L202.759 836.548ZM204.159 840.488C204.159 840.101 203.846 839.788 203.459 839.788C203.072 839.788 202.759 840.101 202.759 840.488L203.459 840.488L204.159 840.488ZM202.759 844.427C202.759 844.814 203.072 845.127 203.459 845.127C203.846 845.127 204.159 844.814 204.159 844.427L203.459 844.427L202.759 844.427ZM204.159 848.366C204.159 847.98 203.846 847.666 203.459 847.666C203.072 847.666 202.759 847.98 202.759 848.366L203.459 848.366L204.159 848.366ZM202.759 852.306C202.759 852.692 203.072 853.006 203.459 853.006C203.846 853.006 204.159 852.692 204.159 852.306L203.459 852.306L202.759 852.306ZM204.159 856.245C204.159 855.858 203.846 855.545 203.459 855.545C203.072 855.545 202.759 855.858 202.759 856.245L203.459 856.245L204.159 856.245ZM202.759 860.184C202.759 860.571 203.072 860.884 203.459 860.884C203.846 860.884 204.159 860.571 204.159 860.184L203.459 860.184L202.759 860.184ZM204.159 864.123C204.159 863.737 203.846 863.423 203.459 863.423C203.072 863.423 202.759 863.737 202.759 864.123L203.459 864.123L204.159 864.123ZM202.759 868.063C202.759 868.449 203.072 868.763 203.459 868.763C203.846 868.763 204.159 868.449 204.159 868.063L203.459 868.063L202.759 868.063ZM204.159 872.002C204.159 871.615 203.846 871.302 203.459 871.302C203.072 871.302 202.759 871.615 202.759 872.002L203.459 872.002L204.159 872.002ZM202.759 875.941C202.759 876.328 203.072 876.641 203.459 876.641C203.846 876.641 204.159 876.328 204.159 875.941L203.459 875.941L202.759 875.941ZM204.159 879.881C204.159 879.494 203.846 879.181 203.459 879.181C203.072 879.181 202.759 879.494 202.759 879.881L203.459 879.881L204.159 879.881ZM202.759 883.82C202.759 884.206 203.072 884.52 203.459 884.52C203.846 884.52 204.159 884.206 204.159 883.82L203.459 883.82L202.759 883.82ZM204.159 887.759C204.159 887.373 203.846 887.059 203.459 887.059C203.072 887.059 202.759 887.373 202.759 887.759L203.459 887.759L204.159 887.759ZM202.759 891.698C202.759 892.085 203.072 892.398 203.459 892.398C203.846 892.398 204.159 892.085 204.159 891.698L203.459 891.698L202.759 891.698ZM204.159 895.638C204.159 895.251 203.846 894.938 203.459 894.938C203.072 894.938 202.759 895.251 202.759 895.638L203.459 895.638L204.159 895.638ZM202.759 899.577C202.759 899.964 203.072 900.277 203.459 900.277C203.846 900.277 204.159 899.964 204.159 899.577L203.459 899.577L202.759 899.577ZM204.159 903.516C204.159 903.13 203.846 902.816 203.459 902.816C203.072 902.816 202.759 903.13 202.759 903.516L203.459 903.516L204.159 903.516ZM202.759 907.456C202.759 907.842 203.072 908.156 203.459 908.156C203.846 908.156 204.159 907.842 204.159 907.456L203.459 907.456L202.759 907.456ZM204.159 911.395C204.159 911.008 203.846 910.695 203.459 910.695C203.072 910.695 202.759 911.008 202.759 911.395L203.459 911.395L204.159 911.395ZM202.759 915.334C202.759 915.721 203.072 916.034 203.459 916.034C203.846 916.034 204.159 915.721 204.159 915.334L203.459 915.334L202.759 915.334ZM204.159 919.273C204.159 918.887 203.846 918.573 203.459 918.573C203.072 918.573 202.759 918.887 202.759 919.273L203.459 919.273L204.159 919.273ZM202.759 923.213C202.759 923.599 203.072 923.913 203.459 923.913C203.846 923.913 204.159 923.599 204.159 923.213L203.459 923.213L202.759 923.213ZM204.159 927.152C204.159 926.765 203.846 926.452 203.459 926.452C203.072 926.452 202.759 926.765 202.759 927.152L203.459 927.152L204.159 927.152ZM202.759 931.091C202.759 931.478 203.072 931.791 203.459 931.791C203.846 931.791 204.159 931.478 204.159 931.091L203.459 931.091L202.759 931.091ZM204.159 935.031C204.159 934.644 203.846 934.331 203.459 934.331C203.072 934.331 202.759 934.644 202.759 935.031L203.459 935.031L204.159 935.031ZM203.459 826.7L202.759 826.7L202.759 828.67L203.459 828.67L204.159 828.67L204.159 826.7L203.459 826.7ZM203.459 832.609L202.759 832.609L202.759 836.548L203.459 836.548L204.159 836.548L204.159 832.609L203.459 832.609ZM203.459 840.488L202.759 840.488L202.759 844.427L203.459 844.427L204.159 844.427L204.159 840.488L203.459 840.488ZM203.459 848.366L202.759 848.366L202.759 852.306L203.459 852.306L204.159 852.306L204.159 848.366L203.459 848.366ZM203.459 856.245L202.759 856.245L202.759 860.184L203.459 860.184L204.159 860.184L204.159 856.245L203.459 856.245ZM203.459 864.123L202.759 864.123L202.759 868.063L203.459 868.063L204.159 868.063L204.159 864.123L203.459 864.123ZM203.459 872.002L202.759 872.002L202.759 875.941L203.459 875.941L204.159 875.941L204.159 872.002L203.459 872.002ZM203.459 879.881L202.759 879.881L202.759 883.82L203.459 883.82L204.159 883.82L204.159 879.881L203.459 879.881ZM203.459 887.759L202.759 887.759L202.759 891.698L203.459 891.698L204.159 891.698L204.159 887.759L203.459 887.759ZM203.459 895.638L202.759 895.638L202.759 899.577L203.459 899.577L204.159 899.577L204.159 895.638L203.459 895.638ZM203.459 903.516L202.759 903.516L202.759 907.456L203.459 907.456L204.159 907.456L204.159 903.516L203.459 903.516ZM203.459 911.395L202.759 911.395L202.759 915.334L203.459 915.334L204.159 915.334L204.159 911.395L203.459 911.395ZM203.459 919.273L202.759 919.273L202.759 923.213L203.459 923.213L204.159 923.213L204.159 919.273L203.459 919.273ZM203.459 927.152L202.759 927.152L202.759 931.091L203.459 931.091L204.159 931.091L204.159 927.152L203.459 927.152Z"
                fill="#818181"
              />
            </g>
          </g>
          <g id="Frame 466">
            <path
              d="M282 945V945.7H284C284.756 945.7 285.493 945.774 286.206 945.915L286.341 945.229C287.915 945.54 289.378 946.16 290.666 947.021L290.278 947.603C291.511 948.428 292.572 949.489 293.397 950.722L293.978 950.333C294.84 951.621 295.459 953.084 295.771 954.658L295.085 954.794C295.226 955.507 295.3 956.244 295.3 957V958.667H296V962H295.3V965.333H296V968.667H295.3V972H296V975.333H295.3V977C295.3 977.756 295.226 978.493 295.085 979.206L295.771 979.341C295.459 980.915 294.84 982.378 293.978 983.666L293.397 983.278C292.572 984.511 291.511 985.572 290.278 986.397L290.666 986.978C289.378 987.84 287.915 988.459 286.341 988.771L286.206 988.085C285.493 988.226 284.756 988.3 284 988.3H282V989H278V988.3H274V989H270V988.3H266V989H262V988.3H258V989H254V988.3H250V989H246V988.3H242V989H238V988.3H234V989H230V988.3H226V989H222V988.3H218V989H214V988.3H210V989H206V988.3H202V989H198V988.3H194V989H190V988.3H186V989H182V988.3H178V989H174V988.3H170V989H166V988.3H162V989H158V988.3H154V989H150V988.3H146V989H142V988.3H138V989H134V988.3H130V989H126V988.3H124C123.244 988.3 122.507 988.226 121.794 988.085L121.658 988.771C120.084 988.459 118.621 987.84 117.333 986.978L117.722 986.397C116.489 985.572 115.428 984.511 114.603 983.278L114.021 983.666C113.16 982.378 112.54 980.915 112.229 979.341L112.915 979.206C112.809 978.671 112.741 978.123 112.714 977.563L112.7 977V975.333H112V972H112.7V968.667H112V965.333H112.7V962H112V958.667H112.7V957C112.7 956.244 112.774 955.507 112.915 954.794L112.229 954.658C112.54 953.084 113.16 951.621 114.021 950.333L114.603 950.722C115.428 949.489 116.489 948.428 117.722 947.603L117.333 947.021C118.621 946.16 120.084 945.54 121.658 945.229L121.794 945.915C122.507 945.774 123.244 945.7 124 945.7H126V945H130V945.7H134V945H138V945.7H142V945H146V945.7H150V945H154V945.7H158V945H162V945.7H166V945H170V945.7H174V945H178V945.7H182V945H186V945.7H190V945H194V945.7H198V945H202V945.7H206V945H210V945.7H214V945H218V945.7H222V945H226V945.7H230V945H234V945.7H238V945H242V945.7H246V945H250V945.7H254V945H258V945.7H262V945H266V945.7H270V945H274V945.7H278V945H282Z"
              stroke="#5220DD"
              strokeWidth={1.4}
              strokeDasharray="4 4"
            />
            <g id="Rich Text Block">
              <text
                fontFamily="Gilroy W05 Medium"
                id="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={128.445} y={972.448}>
                  Healthy vasodilation
                </tspan>
              </text>
            </g>
          </g>
          <g id="Frame 467">
            <path
              d="M683.012 937V937.7H685C685.756 937.7 686.493 937.774 687.206 937.915L687.341 937.229C688.915 937.54 690.378 938.16 691.666 939.021L691.278 939.603C692.511 940.428 693.572 941.489 694.397 942.722L694.978 942.333C695.84 943.621 696.459 945.084 696.771 946.658L696.085 946.794C696.226 947.507 696.3 948.244 696.3 949V951H697V955H696.3V959H697V963H696.3V967H697V971H696.3V975H697V979H696.3V983H697V987H696.3V991H697V995H696.3V997C696.3 997.756 696.226 998.493 696.085 999.206L696.771 999.341C696.459 1000.92 695.84 1002.38 694.978 1003.67L694.397 1003.28C693.572 1004.51 692.511 1005.57 691.278 1006.4L691.666 1006.98C690.378 1007.84 688.915 1008.46 687.341 1008.77L687.206 1008.08C686.493 1008.23 685.756 1008.3 685 1008.3H683.012V1009H679.036V1008.3H675.06V1009H671.083V1008.3H667.107V1009H663.131V1008.3H659.154V1009H655.179V1008.3H651.202V1009H647.227V1008.3H643.25V1009H639.273V1008.3H635.298V1009H631.321V1008.3H627.345V1009H623.369V1008.3H619.393V1009H615.417V1008.3H611.44V1009H607.464V1008.3H603.488V1009H599.512V1008.3H595.536V1009H591.56V1008.3H587.583V1009H583.607V1008.3H579.631V1009H575.654V1008.3H571.679V1009H567.702V1008.3H563.727V1009H559.75V1008.3H555.773V1009H551.798V1008.3H547.821V1009H543.846V1008.3H539.869V1009H535.893V1008.3H531.917V1009H527.94V1008.3H523.964V1009H519.988V1008.3H518C517.244 1008.3 516.507 1008.23 515.794 1008.08L515.658 1008.77C514.084 1008.46 512.621 1007.84 511.333 1006.98L511.722 1006.4C510.489 1005.57 509.428 1004.51 508.603 1003.28L508.021 1003.67C507.16 1002.38 506.54 1000.92 506.229 999.341L506.915 999.206C506.809 998.671 506.741 998.123 506.714 997.563L506.7 997V995H506V991H506.7V987H506V983H506.7V979H506V975H506.7V971H506V967H506.7V963H506V959H506.7V955H506V951H506.7V949C506.7 948.244 506.774 947.507 506.915 946.794L506.229 946.658C506.54 945.084 507.16 943.621 508.021 942.333L508.603 942.722C509.428 941.489 510.489 940.428 511.722 939.603L511.333 939.021C512.621 938.16 514.084 937.54 515.658 937.229L515.794 937.915C516.507 937.774 517.244 937.7 518 937.7H519.988V937H523.964V937.7H527.94V937H531.917V937.7H535.893V937H539.869V937.7H543.846V937H547.821V937.7H551.798V937H555.773V937.7H559.75V937H563.727V937.7H567.702V937H571.679V937.7H575.655V937H579.631V937.7H583.607V937H587.583V937.7H591.56V937H595.536V937.7H599.512V937H603.488V937.7H607.464V937H611.44V937.7H615.417V937H619.393V937.7H623.369V937H627.346V937.7H631.321V937H635.298V937.7H639.273V937H643.25V937.7H647.227V937H651.202V937.7H655.179V937H659.154V937.7H663.131V937H667.107V937.7H671.083V937H675.06V937.7H679.036V937H683.012Z"
              stroke="#5220DD"
              strokeWidth={1.4}
              strokeDasharray="4 4"
            />
            <g id="Rich Text Block_2">
              <text
                fontFamily="Gilroy W05 Medium"
                id="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud_2"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={537.148} y={964.448}>
                  Regulates muscle{" "}
                </tspan>
                <tspan x={522.297} y={992.448}>
                  movement and mood
                </tspan>
              </text>
            </g>
          </g>
          <g id="Frame 468">
            <path
              d="M864.982 937V937.7H867C867.756 937.7 868.493 937.774 869.206 937.915L869.341 937.229C870.915 937.54 872.378 938.16 873.666 939.021L873.278 939.603C874.511 940.428 875.572 941.489 876.397 942.722L876.978 942.333C877.84 943.621 878.459 945.084 878.771 946.658L878.085 946.794C878.226 947.507 878.3 948.244 878.3 949V951H879V955H878.3V959H879V963H878.3V967H879V971H878.3V975H879V979H878.3V983H879V987H878.3V991H879V995H878.3V997C878.3 997.756 878.226 998.493 878.085 999.206L878.771 999.341C878.459 1000.92 877.84 1002.38 876.978 1003.67L876.397 1003.28C875.572 1004.51 874.511 1005.57 873.278 1006.4L873.666 1006.98C872.378 1007.84 870.915 1008.46 869.341 1008.77L869.206 1008.08C868.493 1008.23 867.756 1008.3 867 1008.3H864.982V1009H860.946V1008.3H856.911V1009H852.875V1008.3H848.839V1009H844.804V1008.3H840.768V1009H836.732V1008.3H832.696V1009H828.661V1008.3H824.625V1009H820.589V1008.3H816.554V1009H812.518V1008.3H808.482V1009H804.446V1008.3H800.411V1009H796.375V1008.3H792.339V1009H788.304V1008.3H784.268V1009H780.232V1008.3H776.196V1009H772.161V1008.3H768.125V1009H764.089V1008.3H760.054V1009H756.018V1008.3H754C753.244 1008.3 752.507 1008.23 751.794 1008.08L751.658 1008.77C750.084 1008.46 748.621 1007.84 747.333 1006.98L747.722 1006.4C746.489 1005.57 745.428 1004.51 744.603 1003.28L744.021 1003.67C743.16 1002.38 742.54 1000.92 742.229 999.341L742.915 999.206C742.809 998.671 742.741 998.123 742.714 997.563L742.7 997V995H742V991H742.7V987H742V983H742.7V979H742V975H742.7V971H742V967H742.7V963H742V959H742.7V955H742V951H742.7V949C742.7 948.244 742.774 947.507 742.915 946.794L742.229 946.658C742.54 945.084 743.16 943.621 744.021 942.333L744.603 942.722C745.428 941.489 746.489 940.428 747.722 939.603L747.333 939.021C748.621 938.16 750.084 937.54 751.658 937.229L751.794 937.915C752.507 937.774 753.244 937.7 754 937.7H756.018V937H760.054V937.7H764.089V937H768.125V937.7H772.161V937H776.196V937.7H780.232V937H784.268V937.7H788.304V937H792.339V937.7H796.375V937H800.411V937.7H804.446V937H808.482V937.7H812.518V937H816.554V937.7H820.589V937H824.625V937.7H828.661V937H832.696V937.7H836.732V937H840.768V937.7H844.804V937H848.839V937.7H852.875V937H856.911V937.7H860.946V937H864.982Z"
              stroke="#5220DD"
              strokeWidth={1.4}
              strokeDasharray="4 4"
            />
            <g id="Rich Text Block_3">
              <text
                fontFamily="Gilroy W05 Medium"
                id="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud_3"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={763.75} y={964.448}>
                  Adrenaline &{" "}
                </tspan>
                <tspan x={758.391} y={992.448}>
                  Noradrenaline
                </tspan>
              </text>
            </g>
          </g>
          <path
            id="Vector 433"
            d="M870 809L877 813.041V804.959L870 809ZM918.992 809V809.7H919.692V809H918.992ZM918.992 754V753.3H918.292V754H918.992ZM876.3 809V809.7H918.992V809V808.3H876.3V809ZM918.992 809H919.692V754H918.992H918.292V809H918.992ZM918.992 754V754.7H1051V754V753.3H918.992V754Z"
            fill="#282828"
          />
          <path
            id="Vector 434"
            d="M891 971L898 975.041V966.959L891 971ZM928.039 971V971.7H928.739V971H928.039ZM928.039 764V763.3H927.339V764H928.039ZM897.3 971V971.7H928.039V971V970.3H897.3V971ZM928.039 971H928.739V764H928.039H927.339V971H928.039ZM928.039 764V764.7H1048V764V763.3H928.039V764Z"
            fill="#282828"
          />
          <path
            id="Ellipse 10"
            d="M1182.97 416L1187.52 412.451L1182.17 410.282L1182.97 416ZM1184.66 411.832L1185.11 412.036C1195.25 389.326 1218.03 373.5 1244.5 373.5V373V372.5C1217.62 372.5 1194.49 388.572 1184.2 411.629L1184.66 411.832ZM1244.5 373V373.5C1272.55 373.5 1296.46 391.271 1305.56 416.172L1306.03 416L1306.5 415.828C1297.26 390.546 1272.99 372.5 1244.5 372.5V373Z"
            fill="#282828"
          />
          <path
            id="Vector 431"
            d="M204 577H843.215L999 534"
            stroke="#818181"
            strokeWidth={1.4}
            strokeDasharray="4 4"
          />
          <path
            id="Vector 435"
            d="M1088 869V869.7H1088.7V869H1088ZM1014 869V868.3H1013.3V869H1014ZM1014 945H1013.3V945.7H1014V945ZM1088 945H1088.7V944.3H1088V945ZM1088 972L1092.04 965H1083.96L1088 972ZM1088 774H1087.3V869H1088H1088.7V774H1088ZM1088 869V868.3H1014V869V869.7H1088V869ZM1014 869H1013.3V890H1014H1014.7V869H1014ZM1014 890H1013.3V945H1014H1014.7V890H1014ZM1014 945V945.7H1088V945V944.3H1014V945ZM1088 945H1087.3V965.7H1088H1088.7V945H1088Z"
            fill="#282828"
          />
          <path
            id="Vector 436"
            d="M1109 869V869.7H1108.3V869H1109ZM1183 869V868.3H1183.7V869H1183ZM1183 945H1183.7V945.7H1183V945ZM1109 945H1108.3V944.3H1109V945ZM1109 972L1104.96 965H1113.04L1109 972ZM1109 774H1109.7V869H1109H1108.3V774H1109ZM1109 869V868.3H1183V869V869.7H1109V869ZM1183 869H1183.7V890H1183H1182.3V869H1183ZM1183 890H1183.7V945H1183H1182.3V890H1183ZM1183 945V945.7H1109V945V944.3H1183V945ZM1109 945H1109.7V965.7H1109H1108.3V945H1109Z"
            fill="#282828"
          />
          <g id="report-label_3">
            <g id="Report titles_12">
              <rect width={126} height={28} transform="translate(349 794)" fill="white" />
              <text
                fontFamily="Gilroy W05 Regular"
                id="25-Hydroxy Vitamin D_12"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={349.422} y={814.12}>
                  Fatty Aldehyde
                </tspan>
              </text>
            </g>
          </g>
          <g id="report-label_4">
            <g id="Report titles_13">
              <rect width={64} height={28} transform="translate(71 766)" fill="white" />
              <text
                fontFamily="Gilroy W05 Regular"
                id="25-Hydroxy Vitamin D_13"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={71.3359} y={785.44}>
                  Citrulline
                </tspan>
              </text>
            </g>
          </g>
          <g id="report-label_5">
            <g id="Report titles_14">
              <rect width={118} height={52} transform="translate(1123 802)" fill="white" />
              <text
                fontFamily="Gilroy W05 Regular"
                id="25-Hydroxy Vitamin D_14"
                fill="#818181"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={1123} y={816.08}>
                  Adds methyl group to{" "}
                </tspan>
                <tspan x={1123} y={832.08}>
                  inactivate hazardous{" "}
                </tspan>
                <tspan x={1123} y={848.08}>
                  catechol estrogens
                </tspan>
              </text>
            </g>
          </g>
          <g id="report-label_6">
            <g id="Report titles_15">
              <rect width={62} height={20} transform="translate(963 727)" fill="white" />
              <text
                fontFamily="Gilroy W05 Regular"
                id="25-Hydroxy Vitamin D_15"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={963.291} y={741.08}>
                  Breakdown
                </tspan>
              </text>
            </g>
          </g>
          <g id="report-label_7">
            <g id="Report titles_16">
              <rect width={124} height={28} transform="translate(225 752)" fill="white" />
              <text
                fontFamily="Gilroy W05 Regular"
                id="25-Hydroxy Vitamin D_16"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={225.32} y={771.44}>
                  Coupled Enzyme
                </tspan>
              </text>
            </g>
          </g>
          <g id="report-label_8">
            <g id="Report titles_17">
              <rect width={78} height={28} transform="translate(564 794)" fill="white" />
              <text
                fontFamily="Gilroy W05 Regular"
                id="25-Hydroxy Vitamin D_17"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={564.091} y={814.12}>
                  Serotonin
                </tspan>
              </text>
            </g>
            <g id="lines_12">
              <path
                id="Vector_19"
                d="M603.659 826.7C603.659 826.314 603.346 826 602.959 826C602.572 826 602.259 826.314 602.259 826.7L602.959 826.7L603.659 826.7ZM602.959 937L607 930L598.918 930L602.959 937ZM602.259 828.67C602.259 829.056 602.572 829.37 602.959 829.37C603.346 829.37 603.659 829.056 603.659 828.67L602.959 828.67L602.259 828.67ZM603.659 832.609C603.659 832.223 603.346 831.909 602.959 831.909C602.572 831.909 602.259 832.223 602.259 832.609L602.959 832.609L603.659 832.609ZM602.259 836.548C602.259 836.935 602.572 837.248 602.959 837.248C603.346 837.248 603.659 836.935 603.659 836.548L602.959 836.548L602.259 836.548ZM603.659 840.488C603.659 840.101 603.346 839.788 602.959 839.788C602.572 839.788 602.259 840.101 602.259 840.488L602.959 840.488L603.659 840.488ZM602.259 844.427C602.259 844.814 602.572 845.127 602.959 845.127C603.346 845.127 603.659 844.814 603.659 844.427L602.959 844.427L602.259 844.427ZM603.659 848.366C603.659 847.98 603.346 847.666 602.959 847.666C602.572 847.666 602.259 847.98 602.259 848.366L602.959 848.366L603.659 848.366ZM602.259 852.306C602.259 852.692 602.572 853.006 602.959 853.006C603.346 853.006 603.659 852.692 603.659 852.306L602.959 852.306L602.259 852.306ZM603.659 856.245C603.659 855.858 603.346 855.545 602.959 855.545C602.572 855.545 602.259 855.858 602.259 856.245L602.959 856.245L603.659 856.245ZM602.259 860.184C602.259 860.571 602.572 860.884 602.959 860.884C603.346 860.884 603.659 860.571 603.659 860.184L602.959 860.184L602.259 860.184ZM603.659 864.123C603.659 863.737 603.346 863.423 602.959 863.423C602.572 863.423 602.259 863.737 602.259 864.123L602.959 864.123L603.659 864.123ZM602.259 868.063C602.259 868.449 602.572 868.763 602.959 868.763C603.346 868.763 603.659 868.449 603.659 868.063L602.959 868.063L602.259 868.063ZM603.659 872.002C603.659 871.615 603.346 871.302 602.959 871.302C602.572 871.302 602.259 871.615 602.259 872.002L602.959 872.002L603.659 872.002ZM602.259 875.941C602.259 876.328 602.572 876.641 602.959 876.641C603.346 876.641 603.659 876.328 603.659 875.941L602.959 875.941L602.259 875.941ZM603.659 879.881C603.659 879.494 603.346 879.181 602.959 879.181C602.572 879.181 602.259 879.494 602.259 879.881L602.959 879.881L603.659 879.881ZM602.259 883.82C602.259 884.206 602.572 884.52 602.959 884.52C603.346 884.52 603.659 884.206 603.659 883.82L602.959 883.82L602.259 883.82ZM603.659 887.759C603.659 887.373 603.346 887.059 602.959 887.059C602.572 887.059 602.259 887.373 602.259 887.759L602.959 887.759L603.659 887.759ZM602.259 891.698C602.259 892.085 602.572 892.398 602.959 892.398C603.346 892.398 603.659 892.085 603.659 891.698L602.959 891.698L602.259 891.698ZM603.659 895.638C603.659 895.251 603.346 894.938 602.959 894.938C602.572 894.938 602.259 895.251 602.259 895.638L602.959 895.638L603.659 895.638ZM602.259 899.577C602.259 899.964 602.572 900.277 602.959 900.277C603.346 900.277 603.659 899.964 603.659 899.577L602.959 899.577L602.259 899.577ZM603.659 903.516C603.659 903.13 603.346 902.816 602.959 902.816C602.572 902.816 602.259 903.13 602.259 903.516L602.959 903.516L603.659 903.516ZM602.259 907.456C602.259 907.842 602.572 908.156 602.959 908.156C603.346 908.156 603.659 907.842 603.659 907.456L602.959 907.456L602.259 907.456ZM603.659 911.395C603.659 911.008 603.346 910.695 602.959 910.695C602.572 910.695 602.259 911.008 602.259 911.395L602.959 911.395L603.659 911.395ZM602.259 915.334C602.259 915.721 602.572 916.034 602.959 916.034C603.346 916.034 603.659 915.721 603.659 915.334L602.959 915.334L602.259 915.334ZM603.659 919.273C603.659 918.887 603.346 918.573 602.959 918.573C602.572 918.573 602.259 918.887 602.259 919.273L602.959 919.273L603.659 919.273ZM602.259 923.213C602.259 923.599 602.572 923.913 602.959 923.913C603.346 923.913 603.659 923.599 603.659 923.213L602.959 923.213L602.259 923.213ZM603.659 927.152C603.659 926.765 603.346 926.452 602.959 926.452C602.572 926.452 602.259 926.765 602.259 927.152L602.959 927.152L603.659 927.152ZM602.259 931.091C602.259 931.478 602.572 931.791 602.959 931.791C603.346 931.791 603.659 931.478 603.659 931.091L602.959 931.091L602.259 931.091ZM603.659 935.031C603.659 934.644 603.346 934.331 602.959 934.331C602.572 934.331 602.259 934.644 602.259 935.031L602.959 935.031L603.659 935.031ZM602.959 826.7L602.259 826.7L602.259 828.67L602.959 828.67L603.659 828.67L603.659 826.7L602.959 826.7ZM602.959 832.609L602.259 832.609L602.259 836.548L602.959 836.548L603.659 836.548L603.659 832.609L602.959 832.609ZM602.959 840.488L602.259 840.488L602.259 844.427L602.959 844.427L603.659 844.427L603.659 840.488L602.959 840.488ZM602.959 848.366L602.259 848.366L602.259 852.306L602.959 852.306L603.659 852.306L603.659 848.366L602.959 848.366ZM602.959 856.245L602.259 856.245L602.259 860.184L602.959 860.184L603.659 860.184L603.659 856.245L602.959 856.245ZM602.959 864.123L602.259 864.123L602.259 868.063L602.959 868.063L603.659 868.063L603.659 864.123L602.959 864.123ZM602.959 872.002L602.259 872.002L602.259 875.941L602.959 875.941L603.659 875.941L603.659 872.002L602.959 872.002ZM602.959 879.881L602.259 879.881L602.259 883.82L602.959 883.82L603.659 883.82L603.659 879.881L602.959 879.881ZM602.959 887.759L602.259 887.759L602.259 891.698L602.959 891.698L603.659 891.698L603.659 887.759L602.959 887.759ZM602.959 895.638L602.259 895.638L602.259 899.577L602.959 899.577L603.659 899.577L603.659 895.638L602.959 895.638ZM602.959 903.516L602.259 903.516L602.259 907.456L602.959 907.456L603.659 907.456L603.659 903.516L602.959 903.516ZM602.959 911.395L602.259 911.395L602.259 915.334L602.959 915.334L603.659 915.334L603.659 911.395L602.959 911.395ZM602.959 919.273L602.259 919.273L602.259 923.213L602.959 923.213L603.659 923.213L603.659 919.273L602.959 919.273ZM602.959 927.152L602.259 927.152L602.259 931.091L602.959 931.091L603.659 931.091L603.659 927.152L602.959 927.152Z"
                fill="#818181"
              />
            </g>
          </g>
          <g id="report-label_9">
            <g id="Report titles_18">
              <rect width={87} height={28} transform="translate(767 794)" fill="white" />
              <text
                fontFamily="Gilroy W05 Regular"
                id="25-Hydroxy Vitamin D_18"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={767.363} y={814.12}>
                  Dopamine
                </tspan>
              </text>
            </g>
            <g id="lines_13">
              <path
                id="Vector_20"
                d="M811.159 826.7C811.159 826.314 810.846 826 810.459 826C810.072 826 809.759 826.314 809.759 826.7L810.459 826.7L811.159 826.7ZM810.459 937L814.5 930L806.418 930L810.459 937ZM809.759 828.67C809.759 829.056 810.072 829.37 810.459 829.37C810.846 829.37 811.159 829.056 811.159 828.67L810.459 828.67L809.759 828.67ZM811.159 832.609C811.159 832.223 810.846 831.909 810.459 831.909C810.072 831.909 809.759 832.223 809.759 832.609L810.459 832.609L811.159 832.609ZM809.759 836.548C809.759 836.935 810.072 837.248 810.459 837.248C810.846 837.248 811.159 836.935 811.159 836.548L810.459 836.548L809.759 836.548ZM811.159 840.488C811.159 840.101 810.846 839.788 810.459 839.788C810.072 839.788 809.759 840.101 809.759 840.488L810.459 840.488L811.159 840.488ZM809.759 844.427C809.759 844.814 810.072 845.127 810.459 845.127C810.846 845.127 811.159 844.814 811.159 844.427L810.459 844.427L809.759 844.427ZM811.159 848.366C811.159 847.98 810.846 847.666 810.459 847.666C810.072 847.666 809.759 847.98 809.759 848.366L810.459 848.366L811.159 848.366ZM809.759 852.306C809.759 852.692 810.072 853.006 810.459 853.006C810.846 853.006 811.159 852.692 811.159 852.306L810.459 852.306L809.759 852.306ZM811.159 856.245C811.159 855.858 810.846 855.545 810.459 855.545C810.072 855.545 809.759 855.858 809.759 856.245L810.459 856.245L811.159 856.245ZM809.759 860.184C809.759 860.571 810.072 860.884 810.459 860.884C810.846 860.884 811.159 860.571 811.159 860.184L810.459 860.184L809.759 860.184ZM811.159 864.123C811.159 863.737 810.846 863.423 810.459 863.423C810.072 863.423 809.759 863.737 809.759 864.123L810.459 864.123L811.159 864.123ZM809.759 868.063C809.759 868.449 810.072 868.763 810.459 868.763C810.846 868.763 811.159 868.449 811.159 868.063L810.459 868.063L809.759 868.063ZM811.159 872.002C811.159 871.615 810.846 871.302 810.459 871.302C810.072 871.302 809.759 871.615 809.759 872.002L810.459 872.002L811.159 872.002ZM809.759 875.941C809.759 876.328 810.072 876.641 810.459 876.641C810.846 876.641 811.159 876.328 811.159 875.941L810.459 875.941L809.759 875.941ZM811.159 879.881C811.159 879.494 810.846 879.181 810.459 879.181C810.072 879.181 809.759 879.494 809.759 879.881L810.459 879.881L811.159 879.881ZM809.759 883.82C809.759 884.206 810.072 884.52 810.459 884.52C810.846 884.52 811.159 884.206 811.159 883.82L810.459 883.82L809.759 883.82ZM811.159 887.759C811.159 887.373 810.846 887.059 810.459 887.059C810.072 887.059 809.759 887.373 809.759 887.759L810.459 887.759L811.159 887.759ZM809.759 891.698C809.759 892.085 810.072 892.398 810.459 892.398C810.846 892.398 811.159 892.085 811.159 891.698L810.459 891.698L809.759 891.698ZM811.159 895.638C811.159 895.251 810.846 894.938 810.459 894.938C810.072 894.938 809.759 895.251 809.759 895.638L810.459 895.638L811.159 895.638ZM809.759 899.577C809.759 899.964 810.072 900.277 810.459 900.277C810.846 900.277 811.159 899.964 811.159 899.577L810.459 899.577L809.759 899.577ZM811.159 903.516C811.159 903.13 810.846 902.816 810.459 902.816C810.072 902.816 809.759 903.13 809.759 903.516L810.459 903.516L811.159 903.516ZM809.759 907.456C809.759 907.842 810.072 908.156 810.459 908.156C810.846 908.156 811.159 907.842 811.159 907.456L810.459 907.456L809.759 907.456ZM811.159 911.395C811.159 911.008 810.846 910.695 810.459 910.695C810.072 910.695 809.759 911.008 809.759 911.395L810.459 911.395L811.159 911.395ZM809.759 915.334C809.759 915.721 810.072 916.034 810.459 916.034C810.846 916.034 811.159 915.721 811.159 915.334L810.459 915.334L809.759 915.334ZM811.159 919.273C811.159 918.887 810.846 918.573 810.459 918.573C810.072 918.573 809.759 918.887 809.759 919.273L810.459 919.273L811.159 919.273ZM809.759 923.213C809.759 923.599 810.072 923.913 810.459 923.913C810.846 923.913 811.159 923.599 811.159 923.213L810.459 923.213L809.759 923.213ZM811.159 927.152C811.159 926.765 810.846 926.452 810.459 926.452C810.072 926.452 809.759 926.765 809.759 927.152L810.459 927.152L811.159 927.152ZM809.759 931.091C809.759 931.478 810.072 931.791 810.459 931.791C810.846 931.791 811.159 931.478 811.159 931.091L810.459 931.091L809.759 931.091ZM811.159 935.031C811.159 934.644 810.846 934.331 810.459 934.331C810.072 934.331 809.759 934.644 809.759 935.031L810.459 935.031L811.159 935.031ZM810.459 826.7L809.759 826.7L809.759 828.67L810.459 828.67L811.159 828.67L811.159 826.7L810.459 826.7ZM810.459 832.609L809.759 832.609L809.759 836.548L810.459 836.548L811.159 836.548L811.159 832.609L810.459 832.609ZM810.459 840.488L809.759 840.488L809.759 844.427L810.459 844.427L811.159 844.427L811.159 840.488L810.459 840.488ZM810.459 848.366L809.759 848.366L809.759 852.306L810.459 852.306L811.159 852.306L811.159 848.366L810.459 848.366ZM810.459 856.245L809.759 856.245L809.759 860.184L810.459 860.184L811.159 860.184L811.159 856.245L810.459 856.245ZM810.459 864.123L809.759 864.123L809.759 868.063L810.459 868.063L811.159 868.063L811.159 864.123L810.459 864.123ZM810.459 872.002L809.759 872.002L809.759 875.941L810.459 875.941L811.159 875.941L811.159 872.002L810.459 872.002ZM810.459 879.881L809.759 879.881L809.759 883.82L810.459 883.82L811.159 883.82L811.159 879.881L810.459 879.881ZM810.459 887.759L809.759 887.759L809.759 891.698L810.459 891.698L811.159 891.698L811.159 887.759L810.459 887.759ZM810.459 895.638L809.759 895.638L809.759 899.577L810.459 899.577L811.159 899.577L811.159 895.638L810.459 895.638ZM810.459 903.516L809.759 903.516L809.759 907.456L810.459 907.456L811.159 907.456L811.159 903.516L810.459 903.516ZM810.459 911.395L809.759 911.395L809.759 915.334L810.459 915.334L811.159 915.334L811.159 911.395L810.459 911.395ZM810.459 919.273L809.759 919.273L809.759 923.213L810.459 923.213L811.159 923.213L811.159 919.273L810.459 919.273ZM810.459 927.152L809.759 927.152L809.759 931.091L810.459 931.091L811.159 931.091L811.159 927.152L810.459 927.152Z"
                fill="#818181"
              />
            </g>
          </g>
          <g id="report-label_10">
            <g id="Report titles_19">
              <rect width={108} height={28} transform="translate(357 639)" fill="white" />
              <text
                fontFamily="Gilroy W05 Regular"
                id="25-Hydroxy Vitamin D_19"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={357.009} y={659.12}>
                  Alkyl Glycerol
                </tspan>
              </text>
            </g>
            <g id="lines_14">
              <path
                id="Vector_21"
                d="M411.659 671.7L411.659 671L410.259 671L410.259 671.7L410.959 671.7L411.659 671.7ZM410.959 792L415 785L406.918 785L410.959 792ZM410.959 671.7L410.259 671.7L410.259 785.7L410.959 785.7L411.659 785.7L411.659 671.7L410.959 671.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="report-label_11">
            <g id="Report titles_20">
              <rect width={95} height={28} transform="translate(555 639)" fill="white" />
              <text
                fontFamily="Gilroy W05 Regular"
                id="25-Hydroxy Vitamin D_20"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={555.092} y={659.12}>
                  Tryptophan
                </tspan>
              </text>
            </g>
            <g id="lines_15">
              <path
                id="Vector_22"
                d="M603.159 671.7L603.159 671L601.759 671L601.759 671.7L602.459 671.7L603.159 671.7ZM602.459 792L606.5 785L598.418 785L602.459 792ZM602.459 671.7L601.759 671.7L601.759 785.7L602.459 785.7L603.159 785.7L603.159 671.7L602.459 671.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="report-label_12">
            <g id="Report titles_21">
              <rect width={66} height={28} transform="translate(779 639)" fill="white" />
              <text
                fontFamily="Gilroy W05 Regular"
                id="25-Hydroxy Vitamin D_21"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={779.085} y={659.12}>
                  Tyrosine
                </tspan>
              </text>
            </g>
            <g id="lines_16">
              <path
                id="Vector_23"
                d="M812.659 671.7L812.659 671L811.259 671L811.259 671.7L811.959 671.7L812.659 671.7ZM811.959 792L816 785L807.918 785L811.959 792ZM811.959 671.7L811.259 671.7L811.259 785.7L811.959 785.7L812.659 785.7L812.659 671.7L811.959 671.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <path
            id="Ellipse 9"
            d="M1056 529L1063.85 530.937L1061.6 523.172L1056 529ZM1127 438H1126.3C1126.3 479.329 1099.27 514.378 1061.84 526.582L1062.06 527.248L1062.27 527.913C1100.26 515.528 1127.7 479.956 1127.7 438H1127ZM1056 347L1055.83 347.679C1096.34 357.939 1126.3 394.49 1126.3 438H1127H1127.7C1127.7 393.829 1097.29 356.734 1056.17 346.321L1056 347Z"
            fill="#282828"
          />
          <path
            id="Vector 432"
            d="M146 787L153.313 790.443L152.638 782.389L146 787ZM200 764L199.443 763.576C194.61 769.919 178.666 782.722 152.198 785.779L152.278 786.474L152.359 787.17C179.181 784.072 195.479 771.089 200.557 764.424L200 764Z"
            fill="#282828"
          />
          <path
            id="Ellipse 8"
            d="M1006 348L998.081 346.383L1000.64 354.05L1006 348ZM1004.35 528L1004.56 527.333C966.968 515.427 939.7 480.048 939.7 438.253H939H938.3C938.3 480.67 965.975 516.581 1004.14 528.667L1004.35 528ZM939 438.253H939.7C939.7 398.067 964.91 363.812 1000.27 350.651L1000.02 349.995L999.779 349.339C963.886 362.699 938.3 397.468 938.3 438.253H939Z"
            fill="#282828"
          />
          <path id="Vector 430" d="M968 251H1031V329" stroke="#E44C4B" strokeWidth={1.4} />
          <g id="Report titles_22">
            <rect width={50} height={28} transform="translate(1007 511)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              id="25-Hydroxy Vitamin D_22"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={1015.17} y={531.129}>
                BH4
              </tspan>
            </text>
          </g>
          <g id="gene-DHFR" {...geneGroupProps("DHFR", onGeneClick)}>
            <g id="gene-lozenge_5">
              <path
                d="M1123 458C1123 455.791 1124.79 454 1127 454H1219C1221.21 454 1223 455.791 1223 458V486C1223 488.209 1221.21 490 1219 490H1127C1124.79 490 1123 488.209 1123 486V458Z"
                fill={dhfr.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                id="gene-lozenge-label"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={1152.84} y={477.448}>
                  DHFR
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="dhfr"
              groupId="gene-snps"
              genePalette={dhfr}
              startX={1131}
              startY={492}
              snpCount={getGeneSnpCount("DHFR", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-TH" {...geneGroupProps("TH", onGeneClick)}>
            <g id="gene-lozenge_6">
              <path
                d="M762 716C762 713.791 763.791 712 766 712H858C860.209 712 862 713.791 862 716V744C862 746.209 860.209 748 858 748H766C763.791 748 762 746.209 762 744V716Z"
                fill={th.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                id="gene-lozenge-label_2"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={802.281} y={735.448}>
                  TH
                </tspan>
              </text>
              <path
                id="*_3"
                d="M872.748 708.406V710.824L868.818 710.695L871.064 713.934L868.861 715.23L866.874 711.731L864.887 715.23L862.684 713.934L864.93 710.695L861 710.824L861 708.406L864.93 708.535L862.684 705.296L864.887 704L866.874 707.499L868.861 704L871.064 705.296L868.818 708.535L872.748 708.406Z"
                fill="black"
              />
            </g>
            <GeneSnpShapes
              id="th"
              groupId="gene-snps_2"
              genePalette={th}
              startX={770}
              startY={750}
              snpCount={getGeneSnpCount("TH", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-COMT" {...geneGroupProps("COMT", onGeneClick)}>
            <g id="gene-lozenge_7">
              <path
                d="M1049 745C1049 742.791 1050.79 741 1053 741H1145C1147.21 741 1149 742.791 1149 745V773C1149 775.209 1147.21 777 1145 777H1053C1050.79 777 1049 775.209 1049 773V745Z"
                fill={comt.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                id="gene-lozenge-label_3"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={1075.97} y={764.448}>
                  COMT
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="comt"
              groupId="gene-snps_3"
              genePalette={comt}
              startX={1057}
              startY={779}
              snpCount={getGeneSnpCount("COMT", expectedSnps, geneColors)}
            />
          </g>
          <g id="Report titles_23">
            <rect width={62} height={28} transform="translate(980 887)" fill="white" />
            <text
              fontFamily="Gilroy W05 Regular"
              id="25-Hydroxy Vitamin D_23"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={980.414} y={907.12}>
                2-OHE1
              </tspan>
            </text>
          </g>
          <g id="Report titles_24">
            <rect width={63} height={28} transform="translate(1147 887)" fill="white" />
            <text
              fontFamily="Gilroy W05 Regular"
              id="25-Hydroxy Vitamin D_24"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={1147.42} y={907.12}>
                4-OHE1
              </tspan>
            </text>
          </g>
          <g id="Report titles_25">
            <rect width={205} height={28} transform="translate(998 974)" fill="white" />
            <text
              fontFamily="Gilroy W05 Regular"
              id="25-Hydroxy Vitamin D_25"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={998.445} y={993.44}>
                Methoxyestrogens (inactive)
              </tspan>
            </text>
          </g>
          <g id="gene-TPH" {...geneGroupProps("TPH", onGeneClick)}>
            <g id="gene-lozenge_8">
              <path
                d="M552 717C552 714.791 553.791 713 556 713H648C650.209 713 652 714.791 652 717V745C652 747.209 650.209 749 648 749H556C553.791 749 552 747.209 552 745V717Z"
                fill={tph.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                id="gene-lozenge-label_4"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={587.562} y={736.448}>
                  TPH
                </tspan>
              </text>
              <path
                id="*_4"
                d="M662.748 709.406V711.824L658.818 711.695L661.064 714.934L658.861 716.23L656.874 712.731L654.887 716.23L652.684 714.934L654.93 711.695L651 711.824L651 709.406L654.93 709.535L652.684 706.296L654.887 705L656.874 708.499L658.861 705L661.064 706.296L658.818 709.535L662.748 709.406Z"
                fill="black"
              />
            </g>
            <GeneSnpShapes
              id="tph"
              groupId="gene-snps_4"
              genePalette={tph}
              startX={560}
              startY={751}
              snpCount={getGeneSnpCount("TPH", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-NOS3" {...geneGroupProps("NOS3", onGeneClick)}>
            <g id="gene-lozenge_9">
              <path
                d="M154 718C154 715.791 155.791 714 158 714H250C252.209 714 254 715.791 254 718V746C254 748.209 252.209 750 250 750H158C155.791 750 154 748.209 154 746V718Z"
                fill={nos3.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                id="gene-lozenge-label_5"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={183.477} y={737.448}>
                  NOS3
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="nos3"
              groupId="gene-snps_5"
              genePalette={nos3}
              startX={162}
              startY={752}
              snpCount={getGeneSnpCount("NOS3", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-NOS3_2" {...geneGroupProps("NOS3", onGeneClick)}>
            <g id="gene-lozenge_10">
              <path
                d="M863 236C863 233.791 864.791 232 867 232H959C961.209 232 963 233.791 963 236V264C963 266.209 961.209 268 959 268H867C864.791 268 863 266.209 863 264V236Z"
                fill={nos3.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                id="gene-lozenge-label_6"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={892.477} y={255.448}>
                  NOS3
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="nos3-2"
              groupId="gene-snps_6"
              genePalette={nos3}
              startX={871}
              startY={270}
              snpCount={getGeneSnpCount("NOS3", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-GPX1" {...geneGroupProps("GPX1", onGeneClick)}>
            <g id="gene-lozenge_11">
              <path
                d="M297 385C297 382.791 298.791 381 301 381H393C395.209 381 397 382.791 397 385V413C397 415.209 395.209 417 393 417H301C298.791 417 297 415.209 297 413V385Z"
                fill={gpx1.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                id="gene-lozenge-label_7"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={328.656} y={404.448}>
                  GPX1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="gpx1"
              groupId="gene-snps_7"
              genePalette={gpx1}
              startX={305}
              startY={419}
              snpCount={getGeneSnpCount("GPX1", expectedSnps, geneColors)}
            />
          </g>
          <g id="lines_17">
            <path
              id="Vector_24"
              d="M628 250.042L635 254.083V246L628 250.042ZM694.3 250.742H695V249.342H694.3V250.042V250.742ZM634.3 250.042V250.742L694.3 250.742V250.042V249.342L634.3 249.342V250.042Z"
              fill="#E44C4B"
            />
          </g>
          <g id="lines_18">
            <path
              id="Vector_25"
              d="M774 250.042L781 254.083V246L774 250.042ZM856.3 250.742H857V249.342H856.3V250.042V250.742ZM780.3 250.042V250.742L856.3 250.742V250.042V249.342L780.3 249.342V250.042Z"
              fill="#E44C4B"
            />
          </g>
          <g id="Report titles_26">
            <rect width={79} height={52} transform="translate(695 229)" fill="white" />
            <g id="25-Hydroxy Vitamin D_26">
              <text
                fontFamily="Gilroy W05 Medium"
                fill="#E44C4B"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={718.109} y={249.129}>
                  O
                </tspan>
              </text>
              <text
                fontFamily="Gilroy W05 Medium"
                fill="#E44C4B"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={732.506} y={249.129}>
                  &#x2082;{" "}
                </tspan>
              </text>
              <text
                fontFamily="Gilroy W05 Medium"
                fill="#E44C4B"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={741.549} y={249.129}>
                  &#x2022;&#x207b;
                </tspan>
              </text>
            </g>
            <text
              fontFamily="Gilroy W05 Regular"
              id="Sub Label"
              fill="#E44C4B"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={14}
              letterSpacing="0em"
            >
              <tspan x={695.446} y={273.76}>
                Superoxides
              </tspan>
            </text>
          </g>
          <text
            fontFamily="Gilroy W05 Regular"
            id="Toxic"
            fill="#E44C4B"
            style={{ whiteSpace: "pre" }}
            xmlSpace="preserve"
            fontSize={16}
            letterSpacing="0em"
          >
            <tspan x={806.188} y={269.44}>
              Toxic
            </tspan>
          </text>
          <g id="gene-SOD1/3" {...geneGroupProps("SOD1/3", onGeneClick)}>
            <g id="gene-lozenge_12">
              <path
                d="M528 235C528 232.791 529.791 231 532 231H624C626.209 231 628 232.791 628 235V263C628 265.209 626.209 267 624 267H532C529.791 267 528 265.209 528 263V235Z"
                fill={sod1_3.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                id="gene-lozenge-label_8"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={549.992} y={254.448}>
                  SOD1/3
                </tspan>
              </text>
              <path
                id="*_5"
                d="M638.748 227.406V229.824L634.818 229.695L637.064 232.934L634.861 234.23L632.874 230.731L630.887 234.23L628.684 232.934L630.93 229.695L627 229.824L627 227.406L630.93 227.535L628.684 224.296L630.887 223L632.874 226.499L634.861 223L637.064 224.296L634.818 227.535L638.748 227.406Z"
                fill="black"
              />
            </g>
            <GeneSnpShapes
              id="sod1-3"
              groupId="gene-snps_8"
              genePalette={sod1_3}
              startX={536}
              startY={269}
              snpCount={getGeneSnpCount("SOD1/3", expectedSnps, geneColors)}
            />
          </g>
        </g>
      </g>
    </>
  );
};

const SvgMethylationBh4CycleDiagram = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1424}
    height={869}
    viewBox="0 176 1424 869"
    fill="none"
    {...props}
  >
    <MethylationBh4CycleDiagramContent
      geneColors={geneColors}
      expectedSnps={expectedSnps}
      onGeneClick={onGeneClick}
    />
    <defs>
      <clipPath id="clip0_18291_211490">
        <rect width={1424} height={1045} fill="white" />
      </clipPath>
      <clipPath id="clip1_18291_211490">
        <rect width={1424} height={869} fill="white" transform="translate(0 176)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgMethylationBh4CycleDiagram;
